import MobileFooter from '../../components/Mobile/MobileFooter';

const MobileAddresses = () => {
  return (
      <div>
        <h1>Mobile Addresses</h1>
        <MobileFooter />
      </div>
  );
}

export default MobileAddresses;